import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import info from "../Info";

const EducationSection = ({ forceCollapsed = false }) => {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    setCollapsed(forceCollapsed);
  }, [forceCollapsed]);

  return (
    <section
      className="py-4 border-b"
      style={{ borderColor: "var(--border-color)" }}
    >
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.3 }}
      >
        <button
          onClick={() => !forceCollapsed && setCollapsed(!collapsed)}
          className="flex items-center gap-2 w-full text-left mb-3"
        >
          <h2
            className="text-xl font-bold"
            style={{ color: "var(--text-primary)" }}
          >
            Education
          </h2>
          <span
            className="text-xs transition-transform duration-200"
            style={{
              color: "var(--text-tertiary)",
              transform: collapsed ? "rotate(-90deg)" : "rotate(0deg)",
            }}
          >
            ▼
          </span>
        </button>

        <AnimatePresence initial={false}>
          {!collapsed && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="overflow-hidden"
            >
              <div className="space-y-3">
                {/* Bachelor's Degree */}
                <div>
                  <h3
                    className="text-base font-medium"
                    style={{ color: "var(--text-primary)" }}
                  >
                    {info.degree}
                  </h3>
                  <p
                    className="text-sm mt-0.5"
                    style={{ color: "var(--text-secondary)" }}
                  >
                    {info.university}
                  </p>
                  <p
                    className="text-xs mt-0.5"
                    style={{ color: "var(--text-tertiary)" }}
                  >
                    {info.graduationDate} • GPA: {info.gpa}
                  </p>
                </div>

                {/* Master's Degree */}
                <div>
                  <h3
                    className="text-base font-medium"
                    style={{ color: "var(--text-primary)" }}
                  >
                    {info.mastersDegree}
                  </h3>
                  <p
                    className="text-xs mt-0.5"
                    style={{ color: "var(--text-tertiary)" }}
                  >
                    {info.mastersGraduationDate}
                  </p>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </section>
  );
};

export default EducationSection;
